var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "tip01" },
        [
          _vm._v(" " + _vm._s(_vm.$t("placeOrder.automaticPrinting1")) + " "),
          _c(
            "el-link",
            {
              staticStyle: { "font-size": "16px" },
              attrs: {
                href: _vm.$store.getters.expressWmsPluginLink,
                type: "warning",
              },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("placeOrder.automaticPrinting2")) + " "
              ),
            ]
          ),
          _vm._v(" " + _vm._s(_vm.$t("placeOrder.automaticPrinting3")) + " "),
        ],
        1
      ),
      _c(
        "el-form",
        {
          ref: "ruleFormRef",
          attrs: {
            inline: true,
            model: _vm.queryForm,
            "label-position": "top",
            size: "large",
          },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { prop: "number" } },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("orderCenterCont.ExchangeOrders"))),
              ]),
              _c("span", [_vm._v("+")]),
              _c("span", { staticStyle: { "margin-right": "10px" } }, [
                _vm._v(_vm._s(_vm.$t("scripting.consolidation"))),
              ]),
              _c(
                "el-select",
                {
                  staticStyle: {
                    width: "150px",
                    "margin-top": "10px",
                    "margin-right": "5px",
                  },
                  model: {
                    value: _vm.scanType,
                    callback: function ($$v) {
                      _vm.scanType = $$v
                    },
                    expression: "scanType",
                  },
                },
                [
                  _c("el-option", {
                    attrs: {
                      label: _vm.$t("GlobalSetObj.scannerNumber"),
                      value: 1,
                    },
                  }),
                  _c("el-option", {
                    attrs: { label: _vm.$t("newOrder.InvoiceKey"), value: 2 },
                  }),
                ],
                1
              ),
              _c("el-input", {
                ref: "inputRef",
                staticStyle: { width: "400px" },
                attrs: { clearable: "" },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.scannerFun($event)
                  },
                },
                model: {
                  value: _vm.queryForm.number,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.queryForm,
                      "number",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "queryForm.number",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            {
              staticStyle: {
                "border-top": "1px solid #cccccc",
                "margin-top": "-10px",
              },
              attrs: { span: 24 },
            },
            [
              _c("div", { staticStyle: { padding: "7px 0" } }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("GlobalSetObj.package")) + ":"),
                ]),
                _c(
                  "span",
                  { staticStyle: { color: "#f9a025", "font-weight": "bold" } },
                  [_vm._v(_vm._s(_vm.tableDataLeftAll.length))]
                ),
                _c("span", { staticStyle: { "margin-left": "20px" } }, [
                  _vm._v(_vm._s(_vm.$t("mdfeTranslate.TotalWeight")) + ":"),
                ]),
                _c(
                  "span",
                  { staticStyle: { color: "#f9a025", "font-weight": "bold" } },
                  [_vm._v(" " + _vm._s(_vm.weightTotal) + "KG")]
                ),
              ]),
            ]
          ),
          _c(
            "el-col",
            { attrs: { span: 14 } },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.tableDataLeft,
                    "header-cell-style": {
                      background: "#f2f2f2",
                      color: "black",
                    },
                    border: "",
                    height: "600",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("collectionCenter.scanInfo"),
                      align: "center",
                      "min-width": "180",
                      prop: "number",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("orderCenterCont.anjunWaybillNumber"),
                      align: "center",
                      "min-width": "160",
                      prop: "waybillNumber",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              _vm._v(_vm._s(scope.row.waybillNumber || "--")),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("collectionCenter.printTime"),
                      align: "center",
                      "min-width": "180",
                      prop: "scanTime",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("trailer.weight"),
                      align: "center",
                      "min-width": "150",
                      prop: "weight",
                    },
                  }),
                ],
                1
              ),
              _c("el-pagination", {
                staticStyle: { margin: "10px 0", float: "right" },
                attrs: {
                  "current-page": _vm.queryForm.pageNumber,
                  "page-size": _vm.queryForm.pageSize,
                  "page-sizes": [10, 20, 50, 100],
                  total: _vm.queryForm.total,
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 10 } },
            [
              _c(
                "div",
                {
                  staticClass: "flex-start",
                  staticStyle: { "margin-bottom": "10px" },
                },
                [
                  _c("div", [_vm._v(_vm._s(_vm.$t("GlobalSetObj.bagNumber")))]),
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { placeholder: _vm.$t("GlobalSetObj.pleaseInput") },
                    model: {
                      value: _vm.inputBagNumber,
                      callback: function ($$v) {
                        _vm.inputBagNumber =
                          typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "inputBagNumber",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      attrs: { disabled: _vm.isDisable, type: "success" },
                      on: { click: _vm.SealingBag },
                    },
                    [_vm._v(_vm._s(_vm.$t("GlobalSetObj.envelope")) + " ")]
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.tableDataRight,
                    "header-cell-style": {
                      background: "#f2f2f2",
                      color: "black",
                    },
                    border: "",
                    height: "600",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("collectionCenter.BagNumber"),
                      align: "center",
                      prop: "transitBagNumber",
                      width: "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "span",
                              {
                                staticStyle: { cursor: "pointer" },
                                on: {
                                  click: function ($event) {
                                    return _vm.GET_SEAL_RECORD_DETAIL(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(scope.row.transitBagNumber) + " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("collectionCenter.numberPackages"),
                      align: "center",
                      "min-width": "180",
                      prop: "packageCount",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("GlobalSetObj.totalWeightKG"),
                      align: "center",
                      "min-width": "160",
                      prop: "totalWeight",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [_vm._v(_vm._s(scope.row.totalWeight))]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("collectionCenter.sealingBagTime"),
                      align: "center",
                      "min-width": "180",
                      prop: "createTime",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { display: "none" } },
        [_c("pdf", { ref: "pdfPrint", attrs: { src: _vm.viewUrl } })],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false",
            },
          ],
        },
        [
          _c("audio", {
            ref: "errRef",
            attrs: { src: _vm.errorMp3, controls: "controls" },
          }),
          _c("audio", {
            ref: "okRef",
            attrs: { src: _vm.okMp3, controls: "controls" },
          }),
        ]
      ),
      _c("printTipsCom", {
        ref: "printTipsComRef",
        on: { autoPrint: _vm.printFun },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }